<template>
    <v-container fluid>

        <div class="centered-content mt-sm-8 mt-md-12">

            <v-alert border="left" colored-border elevation="2"
                     transition="slide-y-transition"
                     type="success"
                     v-model="isSuccess">
                <div>Si cette adresse email est bien enregistrée auprès de nos services, vous recevrez un email vous
                    permettant de mettre à jour votre mot de passe.
                </div>
                <v-row align="center" class="mt-2" no-gutters>
                    <v-spacer></v-spacer>
                    <v-col class="shrink">
                        <v-btn @click="$router.push('login')" text>Retour</v-btn>
                    </v-col>
                </v-row>
            </v-alert>
            <v-alert border="left" elevation="2"
                     transition="slide-y-transition"
                     type="error"
                     v-model="isUnknownError">
                <div>Une erreur est survenue. Si le problème persiste, contactez le <a
                        href="https://support.yodaforex.com">support Yodaforex</a></div>
                <v-row align="center" class="mt-2" no-gutters>
                    <v-spacer></v-spacer>
                    <v-col class="shrink">
                        <v-btn @click="submit" text>Réessayer</v-btn>
                    </v-col>
                </v-row>
            </v-alert>

            <v-card :disabled="isSuccess">
                <v-card-title class="word-wrap">J'ai oublié mon mot de passe</v-card-title>
                <v-card-text>Saissez l'adresse email avec laquelle vous essayez de vous connecter. Vous recevrez sur
                    cette adresse les instructions pour renouveler votre mot de passe.
                </v-card-text>
                <v-container class="pa-sm-8">
                    <v-form @submit.prevent="submit"
                            ref="loginForm" v-model="isFormValid">
                        <v-row>
                            <v-col>
                                <v-text-field
                                        :rules="[v => !!v || 'L\'email est obligatoire']"
                                        class="thin-outlined"
                                        hide-details label="Email" outlined
                                        v-model="displayedEmail"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-btn :loading="submitting" block color="success"
                                       type="submit">
                                    Envoyer
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                    <v-divider class="ma-6"/>

                    <v-row justify="center">
                        <router-link class="blue-grey--text help-connect-link mb-3" to="/login">Se connecter
                        </router-link>
                    </v-row>

                </v-container>
            </v-card>
        </div>
    </v-container>
</template>

<script>


	export default {
		name: "ForgotPasswordView",
		data() {
			return {
				isUnknownError: false,
				isSuccess: false,
				isFormValid: false,
				submitting: false,
				displayedEmail: ""
			}
		},
		mounted() {
			if (this.$route.params.email) {
				this.displayedEmail = this.$route.params.email;
			}
		},
		methods: {
			submit() {
				this.isUnknownError = false;
				if (!this.submitting) {
					this.submitting = true;
					this.$http.post(this.$config.apiUrl + "/v2/passwords/forgot", {
						email: this.displayedEmail
					})
						.then(r => this.isSuccess = true)
						.catch(e => this.isUnknownError = true)
						.finally(() => this.submitting = false);
				}
			},
		}
	}
</script>

<style scoped>
    .word-wrap {
        word-break: normal;
    }

    .centered-content {
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
    }

    .help-connect-link {
        font-size: smaller;
        text-decoration: none;
    }
</style>
